import React from 'react'
import classNames from 'classnames'

import SectionTitle from './SectionTitle'

import style from './ConsentEmptyListSectionHeader.module.css'

export default function ConsentEmptyListSectionHeader({
  labels,
  consentType,
  indented,
}) {
  return (
    <header
      className={classNames(
        indented ? style.indentedHeader : style.header,
        'js-consent-empty-list-section-header'
      )}
    >
      {labels.map(label => (
        <SectionTitle
          key={label}
          count={0}
          label={label}
          consentType={consentType}
        />
      ))}
    </header>
  )
}
